/**
 * Side menu widget component.
 * @export
 * @class ContentBrowserComponent
 */
 import { AfterViewInit, Component, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
 import { MatIconRegistry } from '@angular/material/icon';
 import { DomSanitizer } from '@angular/platform-browser';
 import { Router, RoutesRecognized } from '@angular/router';
 import { AuthenticationService } from 'src/app/core/services/auth.service';
 import { UserService } from './../../core/services/user.service';
 import { GestemService } from './../../core/services/gestem.service';
 import { Observable, Subject } from 'rxjs';

 interface MenuItem {
   title?: string;
   label?: string;
   icon?: string;
   items?: MenuItem[];
   itemsCallback?: string;
   command?: Function;
   url?: string;
   routerLink?: string;
   context?: string;
   expanded?: boolean;
   disabled?: boolean;
   separator?: boolean;
   style?: Object;
   styleClass?: string;
   acl?: string[];
   id_html?: string;
   flagCSS_selected?: string
 }

 @Component({
   selector: 'myp-side-menu',
   templateUrl: './side-menu.component.html',
   encapsulation: ViewEncapsulation.None,
   styleUrls: ['./side-menu.component.css'],
 })
 export class SideMenuComponent implements OnInit {

   /**
    *
    *
    * @type {MenuItem[]}
    * @memberof SideMenuComponent
    */
   public items: MenuItem[];
   public ente: string = '';
   public acl: string = '';
   public urlAttivita: string = '';
   public urlRichiesta: string = '';
   public urlPanoramica: string = '';
   public selectedItem: string = '';
   @Input('menu') openCloseMenu: Subject<boolean>;

   private getMenuItems(): MenuItem[] {

     let res: MenuItem[] = [
       {
         label: 'Scrivania',
         icon: 'dashboard',
         context: '/',
         title: 'Scrivania',
         items: [{
           label: 'Scrivania',
           url: this.urlPanoramica,
           title: 'Scrivania',
         }]
       },
       {
         label: 'Gestione Emergenze',
         icon: 'account_balance',
         context: '/',
         title: 'Gestione Emergenze',
         items: [{
           label: 'Eventi e Template',
           routerLink: '/lista-eventi',
           title: 'Eventi e Template',
           acl: ['dpcpl', 'dgpe', 'edel'],
           id_html: 'lista-eventi',
           flagCSS_selected: 'eventi'
         }, {
           label: 'Gestione segnalazioni',
           routerLink: '/gestione-segnalazioni',
           title: 'Gestione segnalazioni',
           acl: ['eell', 'dgpe', 'dpcpl', 'edel'],
           id_html: 'lista-segnalazioni',
           flagCSS_selected: 'segnalazioni'
         }, {
           label: 'Richieste',
           routerLink: '/elenco-richieste',
           title: 'Richieste',
           acl: ['dgpe'],
           id_html: 'elenco-richieste',
           flagCSS_selected: 'richieste'
         }, {
           label: 'Gestione invio segnalazioni',
           routerLink: '/gestione-invio-segnalazioni',
           title: 'Gestione invio segnalazioni',
           acl: ['eell'],
           id_html: 'gestione-invio-segnalazioni',
           flagCSS_selected: 'gestioneInvioSegnalazioni'
        }, {
           label: 'Gestione utenti',
           routerLink: '/gestione-utenti',
           title: 'Gestione utenti',
           acl: ['amme'], // Amministratore Ente
           id_html: 'gestione-utenti',
           flagCSS_selected: 'gestioneUtenti'
        },
        // {
        //   label: 'Elenco Invii Segnalazioni',
        //   routerLink: '/elenco-invio-segnalazioni',
        //   title: 'Elenco Invii Segnalazioni',
        //   acl: ['eell'],
        //   id_html: 'elenco-invio-segnalazioni',
        //   flagCSS_selected: 'elencoInviiSegnalazioni'
        // }
      ]
       }
     ];

     return this.filterAuthorizedMenus(res);
   }

   /**
    * @readonly
    * @type {MenuItem}
    * @memberof SideMenuComponent
    */
   public get selectedMenu(): MenuItem {
     return this._selectedMenu;
   }

   /**
    * @private
    * @type {MenuItem}
    * @memberof SideMenuComponent
    */
   private _selectedMenu: MenuItem;

   /**
    *
    *
    * @memberof SideMenuComponent
    */
   public set selectedMenu(item: MenuItem) {
     if(item !== undefined && item !== null) {
      if (item.routerLink) {
        this.router.navigate([`${item.routerLink}`])
      }
      this._selectedMenu = item;
      this.navigateTo = [];
      this.toggleMainMenu();
     }
   }

   /**
    *
    *
    * @type {boolean}
    * @memberof SideMenuComponent
    */
   public mainMenuHidden: boolean = true;

   /**
    *
    *
    * @type {string[]}
    * @memberof SideMenuComponent
    */
   public navigateTo: string[];

   /**
    * Creates an instance of ContentBrowserComponent.
    *
    *
    * @memberOf ContentBrowserComponent
    */
   constructor(
     private router: Router,
     private userService: UserService,
     private matIconRegistry: MatIconRegistry,
     private domSanitizer: DomSanitizer,
     private authenticationService: AuthenticationService,
     private gestemService: GestemService
   ) {


     this.matIconRegistry.addSvgIcon(
       "logo_ven",
       this.domSanitizer.bypassSecurityTrustResourceUrl("assets/images/logo-regioneveneto.svg")
     );

     this.gestemService.getConfig().subscribe(data => {
       sessionStorage.setItem('UrlRichiesta', data[0]);
       this.urlPanoramica = data[0];
       this.authenticationService.getAcl().subscribe(res => {
         sessionStorage.setItem('acl', res.acl);
         this.acl = res.acl;
         this.items = this.getMenuItems();
         this.selectedMenu = this.items[1];
         this.mainMenuHidden = true;
       });
       this.authenticationService.aggiornaMenuObservable.subscribe(res => {
        this.authenticationService.getAcl().subscribe(res => {
          sessionStorage.setItem('acl', res.acl);
          this.acl = res.acl;
          this.items = this.getMenuItems();
          this.selectedMenu = this.items[1];
          this.mainMenuHidden = true;
        });
      });
     });

     this.authenticationService.currentUser.subscribe(res => {
       this.ente = res;
     })


     let routerSubscriber = this.router.events
     .subscribe((event) => {
       if (event instanceof RoutesRecognized) {

         let route: RoutesRecognized = event;
         let url: string = route.urlAfterRedirects ? route.urlAfterRedirects : route.url;
         let segments = [];
         if (this.router.parseUrl(url).root.children['primary']) {
           segments = this.router.parseUrl(url).root.children['primary'].segments;
         }

         let skipContext = false;
         let context: string[] = [];

         segments.forEach(segment => {
           if (skipContext)
             context.push(`/${segment.path}`);

           if (segment.path === 'admin')
             skipContext = true;
         })

         if (context.length > 0) {
           let topLevelContext = context.shift();
           this.navigateTo = context;
           this.items.forEach(item => {
             if (item.context === topLevelContext)
               this._selectedMenu = item;
           })
         }
         //Controllo per voci menù quando ricarico pag
         this.checkIfSelected(event);
       }
     });

   }

   /**
    * Initialization hook for component lifecycle
    *
    *
    * @memberOf ContentBrowserComponent
    */
   public ngOnInit(): void {

     this.checkSeletedWhenOpenMenu();

   }

   /**
    *
    *
    * @memberof SideMenuComponent
    */
   public toggleMainMenu() {
     this.mainMenuHidden = !this.mainMenuHidden;
   }

   private checkIfSelected(event: RoutesRecognized) {
     if (event.url.includes('lista-eventi') || event.url.includes('dettaglio-evento') || event.url.includes('modifica-evento') || event.url.includes('nuovo-evento')) {
       this.selectedItem = 'eventi';
     } else if (event.url.includes('elenco-richieste') || event.url.includes('nuova-richiesta')) {
       this.selectedItem = 'richieste';
     } else if(event.url.includes('gestione-invio-segnalazioni') || event.url.includes("dettaglio-segnalazione")){
       this.selectedItem = 'gestioneInvioSegnalazioni';
     } else if(event.url.includes('elenco-invio-segnalazioni')){
      this.selectedItem = 'elencoInviiSegnalazioni';
     } else if (event.url.includes('gestione-utenti')) {
      this.selectedItem = 'gestioneUtenti';
     } else this.selectedItem = 'segnalazioni';
   }

   /**
    *
    * @private
    * @param {MenuItem[]} menuItems
    * @returns {MenuItem[]}
    * @memberof SideMenuComponent
    */
   private filterAuthorizedMenus(menuItems: MenuItem[]): MenuItem[] {
     const filteredMenus: MenuItem[] = [];
     menuItems.forEach(item => {
       if (item.items) {
         item.items = this.filterAuthorizedMenus(item.items);
       }

       if (!item.acl && ((item.items && item.items.length > 0) || !item.items)) {
         filteredMenus.push(item);
       }
       if (item.acl && ((item.items && item.items.length > 0) || !item.items)) {
         let autorizzato: boolean = false;
         item.acl.forEach(elem => {
           if (elem && this.authenticationService.haveAcl(elem)) {
             autorizzato = true;
           }
         });
         if (autorizzato) {
           filteredMenus.push(item);
         }
       }
     });

     return filteredMenus;
   }

   private checkSeletedWhenOpenMenu() {

     if (this.router.url.includes('lista-eventi') || this.router.url.includes('dettaglio-evento') || this.router.url.includes('modifica-evento') || this.router.url.includes('nuovo-evento')) {
       this.selectedItem = 'eventi';
     } else if (this.router.url.includes('elenco-richieste') || this.router.url.includes('nuova-richiesta')) {
       this.selectedItem = 'richieste';
     } else if(this.router.url.includes('gestione-invio-segnalazioni') || this.router.url.includes("dettaglio-segnalazione")){
       this.selectedItem = 'gestioneInvioSegnalazioni';
     } else if(this.router.url.includes('elenco-invio-segnalazioni')){
      this.selectedItem = 'elencoInviiSegnalazioni';
     } else if (this.router.url.includes('gestione-utenti')) {
      this.selectedItem = 'gestioneUtenti';
     } else this.selectedItem = 'segnalazioni';
   }

 }
